module.exports = __webpack_public_path__ + "static/media/AdobeStock_236751935.740400f4.jpg";